export const damageRatings: Record<string, string[]> = {
  'GR-DRA-1': ['NRI', 'I', 'L/I-1'],
  'GR-DRA-2': ['COR-1', 'L/B-1', 'L/I-2'],
  'GR-DRA-3': ['COR-2', 'L/B-2', 'CR-1'],
  'GR-DRA-4': ['COR-3', 'CR-2'],
  'GR-DRA-5': ['COR-4', 'SWC-1', 'CR-3'],
  'GR-DRA-6': ['SWC-2', 'CR-4', 'SOHIC-1'],
}

export const damageDescriptions: Record<string, string> = {
  NRI: 'No Relevant Indications or No detectable service-related damage.',
  I: 'Inclusions: Small non-metallic defects from fabrication scattered throughout the base material shown as small indications.',
  'L/I-1':
    'Laminations/Inclusions: Non-metallic defects from fabrication that are planar to the OD surface that reduce or remove the back wall signal. These defects show no signs of in-service degradation.',
  'COR-1':
    'Corrosion-1: Corrosion, either general wall loss or pitting 10% or less in depth from the nominal wall thickness.',
  'L/B-1':
    'Laminar/Blistering: Laminar inclusions that show initial signs of blistering or large area de-laminations. Typically, there is a diminished or total loss of back-wall response with a periphery indication of ≤1mm.',
  'L/I-2':
    'Laminar/Inclusions: Indications typical of the initial stages of material degradation, i.e., hydrogen charging/accumulation, etc.',
  'COR-2':
    'Corrosion-2: Corrosion, either general wall-loss or pitting that is greater than 10% up to 20% in depth.',
  'L/B-2':
    'Blistering: Confirmed blistering with a total loss in back-wall response, with a periphery indication of ≥0.040"; typically associated with Wet H2S service.',
  'CR-1':
    'Cracking: Potential shallow I.D. cracking (<10% thickness) that may or may not be associated with service.',
  'COR-3':
    'Corrosion-3: Corrosion, either general wall-loss or pitting that is greater than 20% wall-loss and less than 50% wall loss.',
  'CR-2':
    'Cracking: Confirmed cracking with established lengths and through wall depths greater than 10% thickness and less than or equal to 20% thickness.',
  'COR-4':
    'Corrosion-4: Corrosion, either general wall-loss or pitting that is equal to or greater than 50% wall-loss.',
  'SWC-1':
    'Stepwise Cracking: Blistering that has linked up (multi-levels) with cracks usually embedded and are not yet surface connected.',
  'CR-3':
    'Cracking: Cracking with established lengths and thru-wall depths greater than 20% thickness and less than 50% thickness.',
  'SWC-2':
    'Stepwise Cracking: Blistering that has linked up (multi-levels) with cracks linked to the I.D. or O.D. surface(s).',
  'CR-4':
    'Cracking: Severe cracking with through wall depths equal to or greater than 50% thickness.',
  'SOHIC-1':
    'Cracking (SOHIC): Cracking occurring in wet H2S environments and characterized by stepwise cracks perpendicular to the Heat Affected Zone (HAZ) regardless of through-wall height.',
}

export interface DRAGuideEntry {
  key: string
  mainDRA: string
  subDRA: string
  description: string
}

export const generateDRAGuideData = (): DRAGuideEntry[] => {
  const data: DRAGuideEntry[] = []

  Object.entries(damageRatings).forEach(([mainDRA, subDRAs]) => {
    subDRAs.forEach((subDRA) => {
      data.push({
        key: `${mainDRA}-${subDRA}`,
        mainDRA,
        subDRA,
        description: damageDescriptions[subDRA] || '',
      })
    })
  })

  return data
}

export const getAvailableSubDRAs = (mainDRA: string): string[] => {
  return damageRatings[mainDRA] || []
}

export const getDRADescription = (subDRA: string): string => {
  return damageDescriptions[subDRA] || ''
}
